import { render, staticRenderFns } from "./templateDialog.vue?vue&type=template&id=78df5d9e&scoped=true"
import script from "./templateDialog.vue?vue&type=script&lang=js"
export * from "./templateDialog.vue?vue&type=script&lang=js"
import style0 from "./templateDialog.vue?vue&type=style&index=0&id=78df5d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df5d9e",
  null
  
)

export default component.exports